const IzracunLimita = () => import("@views/app/limit-calculation/limit-calculation.vue");
const RezultatIzracuna = () => import("@views/app/limit-calculation/limit-calculation-result.vue");

export const IzracunLimitaRoutes = [
    {
        component: IzracunLimita,
        name: "izracun_limita",
        path: "izracun-limita"
    },
    {
        component: RezultatIzracuna,
        name: "rezultat_izracuna",
        path: "izracun-limita/rezultat"
    },
];